import React, { useState, useEffect } from 'react';
import { Button, Col, Row, ModalBody, Form, Spinner } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { addNewWaterUseStatus, checkWaterUseStatusExists, updateWaterUseStatus } from '../../../../../slices/waterUseStatus/thunk';
import { setRequireCloseModal } from '../../../../../slices/waterUseStatus/reducer';
import OInput from '../../../../../Components/OElements/OInput';

const WaterUseStatusForm = ({
	dataWaterUseStatus,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const selectorWaterUseStatus = createSelector(
		state => state.WaterUseStatus,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal
	} = useSelector(selectorWaterUseStatus);

	// Validation
	const validation = useFormik({
		// Enable reinitialize when initial values need to be changed
		enableReinitialize: true,
		initialValues: {
			name: dataWaterUseStatus?.name || '',
			disable: dataWaterUseStatus?.disable || false,
		},
		validationSchema: Yup.object({
			name: Yup.string()
				.required('Campo requerido')
				.test('name-exists-check', 'Estado de Uso ya existe', async function (value) {
					if (value && (!isEdit || value !== dataWaterUseStatus?.name)) {
						const result = await dispatch(checkWaterUseStatusExists(value));
						if (result.payload.exists) {
							return this.createError({ message: 'Estado de Uso ya existe' });
						}
					}
					return true;
				}),
		}),
		validateOnChange: false,
		validateOnBlur: true,
		onSubmit: async values => {
			setIsLoading(true);
			const waterUseStatusData = {
				...values,
				...(isEdit && { _id: dataWaterUseStatus._id }),
			};

			if (isEdit) {
				await dispatch(updateWaterUseStatus(waterUseStatusData));
			} else {
				await dispatch(addNewWaterUseStatus(waterUseStatusData));
			}
			setIsLoading(false);
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
				if (toggleRefetch) {
					setTimeout(() => {
						toggleRefetch();
					}, 100);
				}
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (validation.isValid) setIsLoading(true);
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<Col lg={12}>
						<OInput
							name='name'
							label='Nombre del Estado de Uso'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={
							isLoading ||
							isAdding ||
							isUpdating
						}
					>
						{
							isLoading ||
								isAdding ||
								isUpdating
								? (
									<i className="label-icon"><Spinner size='sm' /></i>
								)
								: <i className="ri-save-3-line label-icon"></i>
						}
						{isEdit ? 'Editar' : 'Crear'} Estado de Uso
					</button>
				</div>
			</div>
		</Form>
	);
};

export default WaterUseStatusForm;
